var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCelebration64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2275_8944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7773 22.6077V16.4592",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 22.6077V16.4592",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2231 22.6077V16.4592",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7788 11.5405C22.7568 12.6107 23.3351 13.4259 23.5139 13.9863C23.7819 14.8268 23.5462 15.5496 22.8511 16.0641C22.156 16.5786 21.4351 16.6034 20.7065 16.0641C19.9779 15.5248 19.7807 14.8112 20.0438 13.9863C20.2192 13.4363 20.7976 12.621 21.7788 11.5405Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0015 11.5404C32.9795 12.6106 33.5578 13.4258 33.7365 13.9861C34.0046 14.8266 33.7689 15.5495 33.0738 16.064C32.3787 16.5785 31.6578 16.6032 30.9292 16.064C30.2006 15.5247 30.0033 14.8111 30.2665 13.9861C30.4419 13.4362 31.0202 12.6209 32.0015 11.5404Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2246 11.5405C43.2026 12.6107 43.7809 13.4259 43.9597 13.9863C44.2277 14.8268 43.992 15.5496 43.2969 16.0641C42.6018 16.5786 41.8809 16.6034 41.1523 16.0641C40.4237 15.5248 40.2265 14.8112 40.4896 13.9863C40.665 13.4363 41.2434 12.621 42.2246 11.5405Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4804 21.9929H53.5197C54.878 21.9929 55.9791 23.094 55.9791 24.4523V51.5056C55.9791 52.8639 54.878 53.965 53.5197 53.965H10.4804C9.1221 53.965 8.021 52.8639 8.021 51.5056V24.4523C8.021 23.094 9.1221 21.9929 10.4804 21.9929Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4804 21.9929H53.5197C54.878 21.9929 55.9791 23.094 55.9791 24.4523V33.0602H8.021V24.4523C8.021 23.094 9.1221 21.9929 10.4804 21.9929Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2275_8944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCelebration64);
export default __webpack_public_path__ + "static/media/pictogramBeaconCelebration64.8cf68b6ae93b0d630f258335e5ef6fab.svg";
export { ForwardRef as ReactComponent };